import { getAppRootURL } from '@/config'

export function getIconUrl(): string {
  return 'https://storage.googleapis.com/renderro-mvp.appspot.com/images/icons/'
}

/**
 * Take hash and get a browsable URL
 *
 * @returns a customer-facing browsing URL
 */
export function getSharedLinkURL(hash: string): string {
  return getAppRootURL() + '/shared-link/' + hash
}
